import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, Paper } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { listEmployeesNotWorking } from "../api/restaurant";
import { getWeekNumber } from "../tools/utils";
import Employee from "../types/api/Employee";

interface AddWorkDaysForEmployeeFormProps {
    open: boolean;
    close?: () => void;
    validate?: (selectedEmployees: number[]) => void;
    selectedWeek: Date;
}

function AddWorkDaysForEmployeesForm(AddWorkDaysForEmployeesProps: AddWorkDaysForEmployeeFormProps) {
    const [employeesNotWorking, setEmployeesNotWorking] = useState<Employee[]>([]);
    const [idOfSelectedEmployees, setIdOfSelectedEmployees] = useState<number[]>([]);

    const fetchNotWorkingEmployees = useCallback(async () => {
        const res = await listEmployeesNotWorking(AddWorkDaysForEmployeesProps.selectedWeek.getUTCFullYear(), getWeekNumber(AddWorkDaysForEmployeesProps.selectedWeek));

        if(res && res.data && res.code === 200){
            setEmployeesNotWorking(res.data);
        }
        
    }, [AddWorkDaysForEmployeesProps.selectedWeek]);

    useEffect(() => {
        if(AddWorkDaysForEmployeesProps.open === true){
            fetchNotWorkingEmployees();
        }
    }, [AddWorkDaysForEmployeesProps.open, fetchNotWorkingEmployees]);

    const handleValidation = () => {
        if(AddWorkDaysForEmployeesProps.validate){
            AddWorkDaysForEmployeesProps.validate(idOfSelectedEmployees)
            fetchNotWorkingEmployees()
        }
    }

    return (
        <Dialog open={AddWorkDaysForEmployeesProps.open} fullWidth={true} maxWidth={"md"}>
            <DialogTitle>Ajouter un employé au planning</DialogTitle>
            <DialogContent>
                Semaine {AddWorkDaysForEmployeesProps.selectedWeek.getFullYear()} - {getWeekNumber(AddWorkDaysForEmployeesProps.selectedWeek)}
                <Paper>
                    <List
                    sx={{
                        maxHeight: 200
                    }}
                    >
                        {
                            employeesNotWorking.length === 0 ?
                                <ListItem>Tout les employés travaillent cette semaine.</ListItem>
                            :
                            employeesNotWorking.map((employee) => (
                                <ListItem key={employee.id}>
                                    <Checkbox 
                                        checked={idOfSelectedEmployees.includes(employee.id)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setIdOfSelectedEmployees([...idOfSelectedEmployees, employee.id]);
                                            } else {
                                                setIdOfSelectedEmployees(idOfSelectedEmployees.filter(id => id !== employee.id));
                                            }
                                        }}
                                    />
                                    {employee.firstName} {employee.lastName}
                                </ListItem>
                            ))
                        }
                    </List>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={AddWorkDaysForEmployeesProps.close}>ANNULER</Button>
                <Button 
                    color="success" 
                    onClick={handleValidation} 
                    autoFocus
                >
                    AJOUTER
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default AddWorkDaysForEmployeesForm;